import { defineMessages } from 'react-intl';

export const customTemplateOnboardingModalMessages = defineMessages({
  title: {
    defaultMessage: 'How to use custom templates',
    id: 'HxOHzUwhjN',
    description: 'Heading for custom template onboarding modal',
  },
  previewRefineSaveTitle: {
    defaultMessage: 'Preview, refine, save.',
    id: 'cbjIKjDo8R',
    description: 'First onboarding step title for custom templates',
  },
  previewRefineSaveDescription: {
    defaultMessage: 'Review the template structure and fine-tune with AI',
    id: '9J1cTT748S',
    description: 'First onboarding step description for custom templates',
  },
  transcribeSessionTitle: {
    defaultMessage: 'Transcribe a session',
    id: 'jtKmWvB1ic',
    description: 'Second onboarding step title for custom templates',
  },
  startSessionDescription: {
    defaultMessage: 'Start a patient session or select an existing one',
    id: 'H3mGSGWfpZ',
    description: 'Second onboarding step description for custom templates',
  },
  selectCustomTemplateTitle: {
    defaultMessage: 'Select your custom template',
    id: '9MwNUwmGfb',
    description: 'Third onboarding step title for custom templates',
  },
  writeNotesUsingDescription: {
    defaultMessage: 'AI will write notes using your custom template',
    id: 'K+KtDjrS8f',
    description: 'Third onboarding step description for custom templates',
  },
  getStarted: {
    defaultMessage: 'Get started',
    id: 'S4GQDv6r4/',
    description: 'Primary action to dismiss custom template onboarding modal',
  },
});
